/** Formate un temps de course : « 12,34 s » ou « DNF » si le coureur n'a pas fini. */
export function formatTime(ms: number | null): string {
  if (ms === null) return 'DNF';
  return `${(ms / 1000).toFixed(2).replace('.', ',')} s`;
}

export function formatSeconds(ms: number | null): string {
  if (ms === null) return '';
  return `${Math.max(0, Math.ceil(ms / 1000))} s`;
}
